import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Users, Plus, Car } from "lucide-react";

const PURPLE = "#2B1E4A";
const GOLD = "#F5B400";

export default function LogisticaDrivers() {
  const [rows, setRows] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "", vehicle_description: "", vehicle_plate: "" });

  const load = () => api.get("/delivery-drivers").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!f.name || !f.email || f.password.length < 6) return toast.error("Nome, email e senha (min 6)");
    try { await api.post("/delivery-drivers", f); toast.success("Entregador criado"); setShowNew(false); setF({ name: "", email: "", password: "", phone: "", vehicle_description: "", vehicle_plate: "" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const toggle = async (d) => { try { await api.put(`/delivery-drivers/${d.id}`, { active: !d.active }); load(); } catch { toast.error("Erro"); } };

  return (
    <div className="space-y-4 p-4 lg:p-8" data-testid="rota-drivers-page">
      <div className="flex items-center gap-3 rounded-2xl p-5 text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, #B5179E)` }}>
        <span className="grid h-11 w-11 place-items-center rounded-xl" style={{ background: GOLD }}><Users size={22} className="text-[#2B1E4A]" /></span>
        <div className="flex-1"><div className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: GOLD }}>CRIS ROTA</div><h1 className="font-display text-xl font-bold">Entregadores</h1></div>
        <button onClick={() => setShowNew((v) => !v)} className="flex items-center gap-1 rounded-xl px-3 py-2 text-sm font-bold text-[#2B1E4A]" style={{ background: GOLD }} data-testid="rota-new-driver-btn"><Plus size={15} /> Novo</button>
      </div>

      {showNew && (
        <div className="grid gap-2 rounded-2xl border border-border bg-white p-4 sm:grid-cols-2" data-testid="rota-new-driver-form">
          <input placeholder="Nome" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" data-testid="driver-name" />
          <input placeholder="Email (login)" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" data-testid="driver-email" />
          <input placeholder="Senha (min 6)" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" data-testid="driver-password" />
          <input placeholder="Telefone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" data-testid="driver-phone" />
          <input placeholder="Veículo" value={f.vehicle_description} onChange={(e) => setF({ ...f, vehicle_description: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" />
          <input placeholder="Placa" value={f.vehicle_plate} onChange={(e) => setF({ ...f, vehicle_plate: e.target.value })} className="rounded-xl border border-border px-3 py-2 text-sm" />
          <button onClick={create} className="rounded-xl px-4 py-2 text-sm font-bold text-white sm:col-span-2" style={{ background: PURPLE }} data-testid="driver-submit">Criar entregador</button>
        </div>
      )}

      {rows === null ? <div className="p-8 text-center text-sm text-[#9A8A98]">Carregando...</div> :
        rows.length === 0 ? <div className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-[#6B5A69]">Nenhum entregador.</div> : (
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid="rota-drivers-list">
          {rows.map((d) => (
            <div key={d.id} className="rounded-2xl border border-border bg-white p-4" data-testid={`rota-driver-${d.id}`}>
              <div className="flex items-start justify-between">
                <div><div className="font-display font-bold text-brand-dark">{d.name}</div><div className="text-[12px] text-[#8A7788]">{d.phone || "—"}</div></div>
                <button onClick={() => toggle(d)} className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${d.active ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"}`} data-testid={`driver-toggle-${d.id}`}>{d.active ? "Ativo" : "Inativo"}</button>
              </div>
              {(d.vehicle_description || d.vehicle_plate) && <div className="mt-2 flex items-center gap-1 text-[12px] text-[#6B5A69]"><Car size={13} /> {d.vehicle_description} {d.vehicle_plate ? `· ${d.vehicle_plate}` : ""}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
